import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import Heading from '@bibliocommons/heading';
import { ExpandableList } from '@bibliocommons/expandable';

import FieldValue from 'app/components/bibs/shared/MetadataDisplay/FieldValue';
import { fieldValueShape } from 'app/shapes/bibPage';

import './Contains.scss';

const MAX_ITEMS_DISPLAYED = 3;

export default function Contains({ containedWork, trackFieldItemClick }) {
  if (!containedWork || !containedWork.size) return null;

  function renderItems() {
    const renderWork = work => <FieldValue value={work} handleClick={() => trackFieldItemClick(work)} />;
    const getItemKey = item => item.getIn(['primary', 'values', 0]);

    return (
      <ExpandableList
        list={containedWork}
        getItemKey={getItemKey}
        renderItem={renderWork}
        collapseCount={MAX_ITEMS_DISPLAYED}
        expandLinkHref="#show-more-contains"
        stacked
        textKey="contains"
      />
    );
  }

  return (
    <div className="cp-contains">
      <Heading tagName="h3" size="medium" variant>
        <FormattedMessage id="bib_metadata_category_contains" />
      </Heading>
      {renderItems()}
    </div>
  );
}

Contains.propTypes = {
  containedWork: ImmutablePropTypes.listOf(fieldValueShape),
  trackFieldItemClick: PropTypes.func.isRequired
};
